
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/order-status/[hash]",
      function () {
        return require("private-next-pages/order-status/[hash].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/order-status/[hash]"])
      });
    }
  